import { useEffect } from 'react';

import { selectUser } from 'store';

import { useAppSelector } from 'hooks';
import { socketClose, socketInit } from 'socket';
import { getAccessToken, selectSessionScope } from 'utils/authSession';
import SocketFrontDesk from 'socket/socketFrontDesk';
import SocketMessages from 'socket/socketMessages';

/**
 * Connects the messages and front desk sockets once per session. Keyed on the session, not the token:
 * a renewal (about every 14 minutes for a login-service session) must not tear the sockets down,
 * and each handshake reads the current token itself (socketInit).
 */
export const useSocketLifecycle = () => {
  const hasAccessToken = !!useAppSelector(selectUser)?.accessToken;
  const sessionScope = useAppSelector(selectSessionScope);

  useEffect(() => {
    if (!hasAccessToken) return;

    socketInit(SocketMessages, getAccessToken());
    socketInit(SocketFrontDesk, getAccessToken());

    return () => {
      socketClose(SocketMessages);
      socketClose(SocketFrontDesk);
    };
  }, [hasAccessToken, sessionScope]);
};
